import { Component, Input } from '@angular/core';
import { DescribedTemplateParameter } from './base-email-templates-landing-page.component';

@Component({
  selector: 'app-email-template-parameters',
  templateUrl: './template-parameters.component.html',
  styleUrls: ['./template-parameters.component.scss']
})
export class EmailTemplateParametersComponent {
  @Input()
  replacementParameters: DescribedTemplateParameter[]

  ngOnInit(): void {
  }

  paramToken(param: DescribedTemplateParameter) {
    return '%{' + param.key + '}'
  }

  copyToClipboard(text) {
    let listener = (e: ClipboardEvent) => {
      let clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData('text', text);
      e.preventDefault();
    };

    document.addEventListener('copy', listener, false);
    document.execCommand('copy');
    document.removeEventListener('copy', listener, false);
  }

}
